import { ControlledCheckboxNew } from '@Components/inputs/ControlledInputs';
import type { Control, FieldValues, Path } from 'react-hook-form';

interface SameAddressCheckboxProps<T extends FieldValues> {
  control: Control<T>;
  fieldName: Path<T>;
  label: string;
  onChange: (isChecked: boolean) => void;
}

export const SameAddressCheckbox = <T extends FieldValues>({
  control,
  fieldName,
  label,
  onChange,
}: SameAddressCheckboxProps<T>) => {
  return (
    <div className='h-[20px] md:mb-[24px] mb-[32px]'>
      <ControlledCheckboxNew
        control={control}
        name={fieldName}
        id={fieldName}
        handleOnChange={onChange}
        props={{ label, labelTextColor: 'text-text-main-secondary' }}
      />
    </div>
  );
};
